import React from "react";
import { Formik } from "formik";
import { Radio } from "@material-ui/core";
import { Form, Col, Row, Tab } from "react-bootstrap";
import { NoticeReceipentTypeOptions } from "../../../../../../_helpers/Helpers";

export function PrivateNoticeAddForm({
  eventKey,
  privateNotice,
  btnRef,
  setReceipentType,
  savePrivateNotice
}) {
  return (
    <Formik 
      enableReinitialize={true}
      initialValues={privateNotice}
      onSubmit={(values) => savePrivateNotice(values)}
    >
      {({ handleSubmit, handleChange, setFieldValue, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
          <Tab.Container activeKey={eventKey}>
            <Tab.Content>
              <Tab.Pane eventKey="first">
                <Form.Group as={Row} controlId="receipentType">
                  <Form.Label column sm={2}>
                    Kişiler<span> *</span>
                  </Form.Label>
                  <Col sm={10}>
                    {
                      NoticeReceipentTypeOptions.map(option => (
                        <span key={option.value} className="mr-2">
                          <Radio
                            checked={option.value === values.receipentType}
                            onChange={e => {
                              setReceipentType(option.value);
                              setFieldValue("receipentType", option.value)
                            }}
                          />
                          {option.label}
                        </span>
                      ))
                    }
                  </Col>
                </Form.Group>
              </Tab.Pane>

              <Tab.Pane eventKey="second">
                <Form.Group as={Row} controlId="definition">
                  <Form.Label column sm={2}>
                    Tanımı<span> *</span>
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control type="text" value={values.definition} placeholder="Tanımı" onChange={handleChange} />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="explanation">
                  <Form.Label column sm={2}>
                    Açıklaması<span> *</span>
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control as="textarea" rows="3" value={values.explanation} placeholder="Açıklaması" onChange={handleChange} />
                  </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="attachment">
                  <Form.Label column sm={2}>
                    Ek
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control type="file" className="mt-2" onChange={e => setFieldValue("attachment", e.target.files[0])} />
                    <span className="form-text text-muted">Dosya boyutu en fazla 10 MB olabilir.</span>
                  </Col>
                </Form.Group>

                <Form.Group as={Row}>
                  <Form.Label column sm={2}>
                    Gönderim Türü
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Check
                      inline
                      disabled={true}
                      checked={true}
                      type="checkbox"
                      id="sendingTypeApplication"
                      className="mt-3 mr-12"
                      label="Uygulama"
                    />
                    <Form.Check
                      inline
                      type="checkbox"
                      id="sendingTypeMail"
                      className="mt-3 mr-12"
                      label="Mail"
                      onChange={e => setFieldValue("isSendingTypeMail", e.target.checked)}
                    />
                    <Form.Check
                      inline
                      type="checkbox"
                      id="sendingTypeSms"
                      className="mt-3"
                      label="SMS"
                      onChange={e => setFieldValue("isSendingTypeSms", e.target.checked)}
                    />
                  </Col>
                </Form.Group>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>         

          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}